<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
   <ItemsWaiting v-if="is_fetch" />
    <div  style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
     <div class="d-flex justify-content-between">
       <div class="text-right m-4">
         <h5 style="font-size: 1vw !important"> تعیین ماموریت</h5>
       </div>
       <div class="d-flex" v-if="allItems.length">
         <a   style="margin-top: 1.3vw; margin-left: 0.5vw;" class="btn btn-primary bg-danger border-danger btn-submit-1" v-if="seconder_ban || approver_ban" v-show="!status_show" @click="infoCancelledModal=true">   دلایل عدم تایید</a>

<!--         <a :href="`${this.download_url}/Determining_Mission/all/pdf/by/id/${id_user}?token=${$cookies.get('id_login')}`"  style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 1vw;" class="btn btn-primary btn-submit-1">خروجی PDF</a>-->


       </div>

      </div>
      <center v-if="status_approver">
        <div   class="alert alert-success w-25">
           تایید نهایی!
        </div>
      </center>
            <center v-if="!status_show && allItems.length">

        <div v-if="seconder_ban"  class="alert alert-warning w-50" @click="infoCancelledModal=true" >
          <div v-if="this.$cookies.isKey('type_2')">
            کاربرگ توسط مدیر عامل ؛ تایید نشد!
          </div>
          <div v-else>
            این کاربرگ قبلا توسط شما رد شده است و الان اصلاح شده است!

          </div>
        </div>
      </center>

      <center v-if="!status_show">
        <div v-if="approver_ban" @click="infoCancelledModal=true"  class="alert alert-info" style="width: 30vw;">
          کاربرگ توسط دبیر کمسیون بهره وری ؛ تایید نشد!
        </div>
      </center>
      <center   v-if="status_seconder_step">
        <div v-if="status_seconder" class="alert alert-info w-25">
          در انتظار تایید توسط مدیر عامل
        </div>
        <div v-if="!status_seconder" class="alert alert-info" style="width: 24vw;">
          در انتظار تایید توسط دبیر کمسیون بهره وری
        </div>
      </center>
      <div class="d-flex flex-column p-4" v-if="this.type_two && not_show">
        <div class="d-flex flex-nowrap" >
          <div style="width: 10vw;" class="d-flex flex-column">
            <label class="required">محور ماموریت</label>
            <textarea v-model="axis" name="" class="form-control" id="" cols="30" rows="30"></textarea>

          </div>
          <div style="width: 10vw; margin-right: 1vw;" class="d-flex flex-column">
            <label class="required">عنوان سند بالادستی </label>
            <textarea v-model="title" name="" class="form-control" id="" cols="30" rows="30"></textarea>
          </div>
          <div style="width: 10vw; margin-right: 1vw;" class="d-flex flex-column">
            <label> محدوده ISIC  </label>
            <input type="text" class="form-control" v-model="range">

          </div>
          <div style="width: 10vw; margin-right: 1vw;" class="d-flex flex-column">
            <label class="required">مدل نقش آفرینی</label>

            <input type="text" class="form-control" @click.prevent="type_modal=true" readonly
                   :placeholder="model_one ||
                    model_two||
                    model_tree||
                    model_four||
                    model_five ?
                    (model_one?'سیاست‌گذاری':'')+' ' +(model_two?'تنظیم‌گری':'')+' ' +(model_tree?'خدمات عمومی':'')+' ' +(model_four?'کنترل حاکمیتی':'')+' ' +(model_five?' تأمین مالی':'') : 'انتخاب کنید'"
                   placeholder="انتخاب کنید">

            <div dir="rtl" class="modal__error slide-top" v-show="type_modal" style="z-index: 999999999999999; top: 40%;">
              <div>
                <p>مدل نقش آفرینی  </p>
                <p @click="type_modal=!type_modal">❌</p>
              </div>
              <div>
                <div class="w-100 bg-white d-flex flex-column p-3 rounded align-items-start">
                  <label for="item1">
                    <input :value="true" v-model="model_one" :checked="model_one" type="checkbox" name="" id="item1">
                     سیاست‌گذاری
                  </label>
                  <br>
                  <label for="item12">
                    <input :value="true" v-model="model_two" :checked="model_two" type="checkbox" name="" id="item12">
                    تنظیم‌گری
                  </label>
                  <br>
                  <label for="item13">
                    <input :value="true" v-model="model_tree" :checked="model_tree" type="checkbox" name="" id="item13">
                    خدمات عمومی
                  </label>
                  <br>
                  <label for="item134">
                    <input :value="true" v-model="model_four" :checked="model_four" type="checkbox" name="" id="item134">
                     کنترل حاکمیتی
                  </label>
                  <br>
                  <label for="item1234">
                    <input :value="true" v-model="model_five" :checked="model_five" type="checkbox" name="" id="item1234">
                    تأمین مالی
                  </label>


                </div>


                <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
                  <button class="btn btn-primary btn-approve" @click="type_modal=!type_modal">تایید</button>
                </div>
              </div>
            </div>


          </div>
          <div style="width: 10vw; margin-right: 1vw;" class="d-flex flex-column">
            <label class="required">خروجی </label>
            <vSelect
                v-model="selectExit"
                :options="ListExits"
                dir="rtl"
                label="title"
                allow-clear="true"
                hide-details="false"



            >
              <template v-slot:no-options>موردی یافت نشد</template>
            </vSelect>
          </div>
          <div style="width: 10vw; margin-right: 1vw;" class="d-flex flex-column">
            <label class="required">پیامد </label>
            <button @click="allListConsequencesModal=true" class="btn bg-white" style="border: 1px solid #777; height: 2vw; display: grid; place-content: center">
              {{selectedConsequesnces.slice(0,14)}}
            </button>

          </div>
          <div style="width: 10vw; margin-right: 1vw;" class="d-flex flex-column">
            <label class="required">نماگر </label>
            <button @click="allNamaListConsequencesModalMethod" class="btn bg-white" style="border: 1px solid #777; height: 2vw; display: grid; place-content: center">
              {{selected2.slice(0,14)}}
            </button>
          </div>
        </div>

        <div class="d-flex flex-nowrap">


          <div style="width: 10vw;" class="d-flex flex-column">
            <label>کلان خدمت </label>
            <vSelect
                v-model="selectProcess"
                :options="ListProcess"
                dir="rtl"
                label="title"
            >
              <template v-slot:no-options>موردی یافت نشد</template>
            </vSelect>
          </div>
          <div style="width: 10vw; margin-right: 1vw;" class="d-flex flex-column">
            <label>زیر خدمت </label>
            <button @click="allSubProcessMethod" class="btn bg-white" style="border: 1px solid #777; height: 2vw; display: grid; place-content: center">
              {{ListParents[0] ? ListParents[0].title.slice(0,14)+'...' : 'انتخاب کنید'}}
            </button>
          </div>
          <button v-if="!is_update" @click.prevent="store" style="margin-top: 1.3vw; margin-right: 1vw;" class="btn btn-primary btn-submit-1">ذخیره</button>
        <div class="d-flex" v-else>
          <button  @click.prevent="update(id_item)" style="margin-top: 1.3vw; margin-right: 1vw;" class="btn btn-primary btn-submit-1">ویرایش</button>
          <Reset @click.prevent="resetItems" style="width: 1.5vw; height: 1.5vw; transform: translateY(1.3vw); cursor: pointer; margin-right: 1vw;" />
        </div>
        </div>
        <br>
        <hr>
      </div>

      <div class="table-responsive p-5">

        <center v-show="!allItems.length">
          <span v-if="$cookies.isKey('type_2') && isWrite">ماموریت وجود ندارد</span>
          <span v-else-if="!isWrite">دوره ای برای  پایش بهره وری این شرکت فعال نمی باشد
</span>
          <span v-else>
            در انتظار تکمیل کاربرگ توسط دبیرکمیته بهره وری
          </span>
        </center>
        <div style="overflow-y: scroll; height: 50vw;" :style="allItems.length < 19 ? 'height: auto;' : ''">

        <table class="table table-striped" v-show="allItems.length">
          <tbody>
          <tr>
            <th rowspan="2"><strong>ردیف</strong></th>
            <th rowspan="2"><strong>
              محور مأموریتی
            </strong></th>

            <th rowspan="2"><strong>عنوان سند بالادستی </strong></th>
            <th rowspan="2"><strong> محدوده ISIC
              (اختیاری)
            </strong></th>
            <th rowspan="2"><strong>مدل نقش آفرینی</strong></th>
            <th colspan="3"><strong> زنجیره نتایج خدمت </strong></th>

            <th colspan="2"><strong>

              خدمت متناظر</strong></th>
            <th v-if="show_insert">عملیات</th>
          </tr>
          <tr>
            <th>خروجی</th>

            <th>پیامد</th>
            <th>نماگر</th>
            <th>کلان خدمت</th>
            <th> زیرخدمت (اختیاری)</th>
            <th v-if="show_insert">  </th>


          </tr>
          <tr v-for="(item, index) in allItems">
            <td>{{index+1}}</td>
            <td>{{item.axis}}</td>
            <td>{{item.title}}</td>
            <td>{{item.range}}</td>
            <td>{{item.model_name}}</td>
            <td>{{item.definition_of_outputs.title}}</td>
            <td >
              <span style="cursor: pointer; color: blue !important" @click="showItems(item.id)" >مشاهده</span>
            </td>
            <td >
              <span style="cursor: pointer; color: blue !important" @click="showItemsNama(item.id)" >مشاهده</span>
            </td>
            <td>{{item.processes && item.processes.title}}</td>
            <td> <span style="cursor: pointer; color: blue !important" @click="showItemsSubProcess(item.id)" >مشاهده</span></td>
            <td v-if="show_insert">
              <div class="d-flex">
                <a @click.prevent="editMethod(item.id)" href="#"><img class="table-edit-img" src="/img/pen.6428fd02.svg" alt="edit"></a>
                <a @click.prevent="deleteMethod(item.id)" style="margin-right: 0.1vw;" href="#"><img  class="table-delete-img" src="/img/delete.f9fc94bc.svg" alt="delete"></a>
              </div>
            </td>
          </tr>


          </tbody>
        </table>
      </div>
        <br>
        <hr v-if="allItems.length">

        <div v-if="allItems.length">
          <div   class="d-flex align-items-center justify-content-center">
            <a :href="`${this.download_url}/Determining_Mission/all/word/by/id/${id_user}?token=${$cookies.get('id_login')}`"
               style="margin-top: 1.3vw; margin-left: 2vw;" class="btn btn-primary btn-submit-1">خروجی Word</a>
            <a
                v-if="not_show"
                :style="$cookies.isKey('type_2') ? 'width: 10vw': ''"
                style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw; background-color: green; border-color: green" class="btn btn-primary btn-submit-1 "


            >
              <div v-if="!status_loading">

                <span  @click="acceptComplete" v-if="!$cookies.isKey('type_2')">  تایید </span>
                <span  @click="acceptCompleteModal=true" v-else>    ارائه جهت تایید مدیرعامل</span>

              </div>


              <div v-else>
                <div class="loader-line"></div>

              </div>

            </a>

            <div dir="rtl" class="modal__error slide-top" v-show="acceptCompleteModal" style="z-index: 999999999999999; top: 40%;">
              <div>
                <p>اخطار</p>
                <p @click="acceptCompleteModal=!acceptCompleteModal">❌</p>
              </div>
              <div>
                <p>آیا از ارائه به مدیرعامل مطمئن هستید؟</p>

                <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
                  <button @click="acceptCompleteModal=!acceptCompleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
                  <button class="btn btn-primary btn-approve" @click="acceptComplete">تایید</button>
                </div>
              </div>
            </div>
            <a v-if="!$cookies.isKey('type_2') && not_show"   style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw;background-color: red; border-color: red;  " class="btn btn-primary btn-submit-1 "
               @click="acceptComplete2"
            >
              <div v-if="!status_loading2">
                <span >عدم تایید</span>
              </div>

              <div v-else>
                <div class="loader-line"></div>

              </div>
            </a>

          </div>
        </div>
      </div>

    </div>
  </div>
  <!-- modal -->
  <div dir="rtl" class="modal__error slide-top" v-show="allListConsequencesModal"
       style="z-index: 999999999999999999999999999999999999999999999; top: 48%;">
    <div class="d-flex justify-content-between" style="flex-direction: row">
      <p>پیامد ها    </p>
      <p @click="allListConsequencesModal=!allListConsequencesModal">❌</p>
    </div>
    <div class="table-container">
    <div class="table-responsive">

      <table class="table table-striped">
        <thead>
        <tr>
          <th style="width: 1vw !important;">انتخاب</th>
          <th>پیامد  </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in ListConsequences" :key="item.id">
          <td style="width: 1vw;" scope="row"><input v-model="ListConsequencesSelected"  type="checkbox"  :value="item['id']"></td>
          <td>{{ item['title'] }}</td>
        </tr>

        </tbody>
      </table>
    </div>
    </div>
   <center>
     <button class="btn-submit-1 btn-primary" @click="submitListConsequencesSelected">تایید</button>
   </center>
  </div>
  <!-- modal -->
  <div dir="rtl" class="modal__error slide-top" v-show="allNamaListConsequencesModal"
       style="z-index: 999999999999999999999999999999999999999999999; top: 48%;">
    <div class="d-flex justify-content-between" style="flex-direction: row">
      <p>نماگر      </p>
      <p @click="allNamaListConsequencesModal=!allNamaListConsequencesModal">❌</p>
    </div>
    <div style="overflow-y:scroll; width: 100%; height: 10vw;">

    <table class="table table-striped">
      <thead>
      <tr>
        <th style="width: 1vw !important;">انتخاب</th>
        <th>نماگر  </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in otherItems" :key="item.id">
        <td style="width: 1vw;" scope="row"><input v-model="ListConsequencesNAMASelected" type="checkbox"   :value="item['id']"></td>
        <td>{{ item.measurement_chart }}</td>
      </tr>

      </tbody>
    </table>
    </div>
   <center>
     <button class="btn-submit-1 btn-primary" @click="allNamaListConsequencesModal=false">تایید</button>
   </center>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="allSubProcessModal"
       style="z-index: 999999999999999999999999999999999999999999999; top: 48%;">
    <div class="d-flex justify-content-between" style="flex-direction: row">
      <p>زیر فرآیند      </p>
      <p @click="allSubProcessModal=!allSubProcessModal">❌</p>
    </div>
    <div style="overflow-y:scroll; width: 100%; height: 10vw;">

    <table class="table table-striped">
      <thead>
      <tr>
        <th style="width: 1vw !important;">انتخاب</th>
        <th>زیر خدمت  </th>
      </tr>
      </thead>

      <tbody>
      <tr v-for="(item, index) in ListParents" :key="item.id">
        <td style="width: 1vw;" scope="row"><input :id="`dd_${item.id}`" v-model="ListSubSelected" type="checkbox"   :value="item['id']" ></td>
        <td>
          <label :for="`dd_${item.id}`">{{ item.title }}</label>
        </td>
      </tr>

      </tbody>
    </table>
    </div>
   <center>
     <button class="btn-submit-1 btn-primary" @click="allSubProcessModal=false">تایید</button>
   </center>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="allItemsModal"
       style="z-index: 999999999999999999999999999999999999999999999; top: 48%;">
    <div class="d-flex justify-content-between" style="flex-direction: row">
      <p>پیامد ها    </p>
      <p @click="allItemsModal=!allItemsModal">❌</p>
    </div>
    <div v-if="allItemsList.length" >
      <div class="table-container">
        <div class="table-responsive" style=" width: 100%; height: 10vw;">
    <table  class="table table-striped">
      <thead>
      <tr class="sticky-header">
         <th>ردیف  </th>
         <th>پیامد  </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in allItemsList" :key="item.id">
        <td>{{index+1}}</td>
         <td>{{ item['title'] }}</td>
      </tr>

      </tbody>
    </table>
    </div>
    </div>
    </div>
    <center class="bg-white" style="border-radius: 1vw" v-else>
      موردی یافت نشد
    </center>

  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="allItemsModalNama"
       style="z-index: 999999999999999999999999999999999999999999999; top: 48%;">
    <div class="d-flex justify-content-between" style="flex-direction: row">
      <p>نماگر ها    </p>
      <p @click="allItemsModalNama=!allItemsModalNama">❌</p>
    </div>
    <div v-if="allItemsListNama.length" >
      <div class="table-container">
        <div class="table-responsive" style=" width: 100%; height: 10vw;">
    <table  class="table table-striped">
      <thead>
      <tr class="sticky-header">
         <th>ردیف  </th>
         <th>نماگر  </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in allItemsListNama" :key="item.id">
        <td>{{index+1}}</td>
         <td>{{ item['measurement_chart'] }}</td>
      </tr>

      </tbody>
    </table>
    </div>
    </div>
    </div>
    <center class="bg-white" style="border-radius: 1vw" v-else>
      موردی یافت نشد
    </center>

  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="allItemsModalSubProcess"
       style="z-index: 999999999999999999999999999999999999999999999; top: 48%;">
    <div class="d-flex justify-content-between" style="flex-direction: row">
      <p>زیرخدمت ها    </p>
      <p @click="allItemsModalSubProcess=!allItemsModalSubProcess">❌</p>
    </div>
    <div v-if="allItemsListSubProcess.length" style="overflow-y:scroll; width: 100%; height: 10vw;">
      <div class="table-container w-100">
        <div class="table-responsive" style=" width: 100%; height: 10vw;">
          <table  class="table table-striped">
      <thead>
      <tr>
         <th style="width: 1vw;">ردیف  </th>
         <th>نام   </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in allItemsListSubProcess" >
        <td>{{index+1}}</td>
         <td>{{ item }}</td>
      </tr>

      </tbody>
    </table>
    </div>
    </div>
    </div>
    <center class="bg-white" style="border-radius: 1vw" v-else>
      موردی یافت نشد
    </center>

  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(id_item)">تایید</button>
      </div>
    </div>
  </div>


  <div dir="rtl" class="modal__error slide-top" v-show="infoCancelled" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>عدم تایید</p>
      <p @click="infoCancelled=!infoCancelled">❌</p>
    </div>
    <div>
      <p>علت عدم تایید خود را بصورت کامل شرح دهید:</p>
      <textarea v-model="text_info" class="form-control" name="" id="" cols="30" rows="10"></textarea>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="infoCancelled=!infoCancelled" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="acceptComplete3">تایید</button>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="infoCancelledModal" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>دلایل عدم تایید</p>
      <p @click="infoCancelledModal=!infoCancelledModal">❌</p>
    </div>
    <div>
        <div class="bg-white p-3 rounded w-100 text-right">
        <p>{{textAlert}}</p>
      </div>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="infoCancelledModal=false"  class="btn btn-primary btn-back" type="submit">برگشت</button>
      </div>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top" v-show="showReSubmit" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>آیا مطمئن هستید تمامی موارد مشکل دار را رفع کرده اید؟</p>
      <p @click="showReSubmit=!showReSubmit">❌</p>
    </div>
    <div>
        <div class="bg-white p-3 rounded w-100 text-right">
        <p>{{textAlert}}</p>
      </div>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="showReSubmit=false"  class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button @click="acceptComplete4"  class="btn btn-primary btn-submit-1" type="submit">تایید نهایی</button>
      </div>
    </div>
  </div>
</template>


<script>
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import splash from "@/components/Splash/Splash.vue";
import "vue-select/dist/vue-select.css";
import vSelect from "vue-select";
import {useToast} from "vue-toastification";
import router from "@/router";
import Reset from "@/components/Icons/Reset.vue";
import cookies from "vue-cookies";
import BehfamLOGO from "@/components/Icons/BehfamLOGO.vue";
import ItemsWaiting from "@/components/Loaders/ItemsWaiting.vue";

const toast = useToast();

export default {
  computed: {
    cookies() {
      return cookies
    }
  },
  components: {
    ItemsWaiting,
    BehfamLOGO,
    Reset,
    Sidebar,
    splash,
    vSelect
  },
  data() {
    return {
      allItems: [],
      ListExits: [],
      ListProcess: [],
      ListParents: [],
      ListSubSelected: [],
      selectExit: '',
      ListConsequences: [],
      selectConsequences: '',
      selectProcess: '',
      selectParent: '',
      axis: '',
      title: '',
      range: '',
      model: '',
      id_user: '',
      selectedConsequesnces: 'انتخاب کنید',
      selected2: 'انتخاب کنید',
      acceptCompleteModal: false,
      allListConsequencesModal: false,
      allNamaListConsequencesModal: false,
      ListConsequencesSelected: [],
      ListConsequencesNAMASelected: [],
      allItemsModal: false,
      allItemsModalNama: false,
      allItemsList: [],
      allItemsListNama: [],
      otherItems: [],
      allSubProcess: [],
      id_item: '',
      deleteModal: false,
      allSubProcessModal: false,
      is_update: false,
      status_show: false,
      status_loading: false,
      status_loading2: false,
      showReSubmit: false,
      show_insert: false,
      status_seconder: false,
      status_approver: false,
      infoCancelled: false,
      text_info: '',
      seconder_ban: false,
      approver_ban: false,
      textAlert: '',
      infoCancelledModal: false,
      status_seconder_step: false,
      isWrite: false,
      allItemsListSubProcess: [],
      allItemsModalSubProcess: false,
      // *************************
      model_one: false,
      model_two: false,
      model_tree: false,
      model_four: false,
      model_five: false,
      type_modal: false,
      is_fetch: true,
      not_show: true,

    }
  },
  methods: {
    setShow(){
      if (this.$cookies.isKey('type_2')){
        if (this.status_show===false){
          this.show_insert = true
          return;
        }
        this.show_insert = true
      }
      this.show_insert = false
    },
    acceptComplete(){
      this.acceptCompleteModal = false
      if (this.status_show ){
        return;
      }
      if (this.status_loading){
        return;
      }
      if (!this.infoCancelled) {
        if (this.$cookies.isKey('type_1')) {
          if (this.status_show) {
            this.text_info = ''

            this.infoCancelled = true
            return;
          }
        }
      }
      if (this.seconder_ban || this.approver_ban){
        this.showReSubmit=true
        return;
      }
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info){
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Determining_Mission/update_complete`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message){
              toast.success(response.message)
              this.status_show=!this.status_show
              this.status_loading = false
              this.allItem()
            }
            this.infoCancelled = false

          })
          .catch();
    },
    acceptComplete4(){
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info){
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Determining_Mission/update_complete`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message){
              toast.success(response.message)
              this.status_show=!this.status_show
              this.status_loading = false
              this.allItem()
            }
            this.infoCancelled = false
            this.showReSubmit = false

          })
          .catch();
    },
    acceptComplete2(){

      if (this.status_loading){
        return;
      }
      if (!this.infoCancelled) {
        if (this.$cookies.isKey('type_1')) {
          if (this.status_show) {
            this.text_info = ''

            this.infoCancelled = true
            return;
          }
        }
      }
      this.infoCancelled = true


    },
    acceptComplete3(){
      this.status_loading2 = true
     if (!this.status_show){
       var myHeaders = new Headers();
       myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
       var formdata = new FormData();
       if (this.text_info){
         formdata.append('text', this.text_info)
       }
       var requestOptions = {
         method: 'POST',
         headers: myHeaders,
         body: formdata,
         redirect: 'follow'
       };
       fetch(`${this.base_url}/Determining_Mission/update_complete`, requestOptions)
           .then(response => response.json())
           .then(response => {


           })
           .catch();
     }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info){
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Determining_Mission/update_complete`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              this.status_loading2 = false
              return
            }
            if (response.message){
              toast.success(response.message)
              this.status_show=!this.status_show
              this.status_loading2 = false
              this.allItem()
            }
            this.infoCancelled = false

          })
          .catch();
    },
    deleteItemForm(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Determining_Mission/destroy/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
             if (response.message){
               toast.success(response.message)
               this.allItem()
               this.id_item = ''
               this.deleteModal = false
             }
          })
          .catch();
    },
    editMethod(id){
      this.id_item = id
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
        var formdata = new FormData();
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };

        fetch(`${this.base_url}/Determining_Mission/edit/${id}`, requestOptions)
            .then(response => response.json())
            .then(response => {
              const item = response.item
              if (item){
                this.axis = item.axis
                this.title = item.title
                this.range = item.range
                this.model_one = item.model_one
                this.model_two = item.model_two
                this.model_tree = item.model_tree
                this.model_four = item.model_four
                this.model_five = item.model_five
              }
              if (item.definition_of_outputs){
                this.selectExit = item.definition_of_outputs

              }
              if (item.immediate_consequences){
                this.submitListConsequencesSelected()
              }
              if (item.consequences_for_determining_missions){


                  item.consequences_for_determining_missions.forEach((item)=>{
                    this.ListConsequencesSelected.push(item.consequences.id)
                    // this.allNamaListConsequencesModalMethod()

                  })

              }
              if (item.consequences_for_determining_missions_effects){
                  item.consequences_for_determining_missions_effects.forEach((item)=>{
                    this.ListConsequencesNAMASelected.push(item.consequences.id)
                  })
              } if (item.sub_processes_items){
                  item.sub_processes_items.forEach((item)=>{
                    this.ListSubSelected.push(item.id)
                  })
              }
              this.is_update = true
            })
            .catch();



    },
    deleteMethod(id){
      this.id_item = id
      this.deleteModal = true

    },


    allSubProcessMethod(){
      this.allSubProcessModal = true

    },
    allNamaListConsequencesModalMethod(){
      this.otherItems.length=0

      this.ListConsequencesSelected.forEach((item) => {
        // اینجا از تابع find استفاده می‌کنیم تا یک عنصر با شرط مناسب پیدا کنیم
        const foundConsequence = this.ListConsequences.find(consequence => parseInt(consequence.id) === parseInt(item));
        if (foundConsequence) {
          this.otherItems.push(foundConsequence)
        }
      });
      this.allNamaListConsequencesModal = true
    },
    showItems(id){
      this.allItemsList.length=0
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Determining_Mission/all_items/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
           response.items.forEach((item)=>{
             this.allItemsList.push(item)
           })
            this.allItemsModal=true
          })
          .catch();
    },

    showItemsSubProcess(id){
      this.allItemsListSubProcess.length=0
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Determining_Mission/all_items/subProcess/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
           response.items.forEach((item)=>{
             this.allItemsListSubProcess.push(item)
           })
            this.allItemsModalSubProcess=true
          })
          .catch();
    },showItemsNama(id){
      this.allItemsListNama.length=0
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Determining_Mission/all_items/effect/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
           response.items.forEach((item)=>{
             this.allItemsListNama.push(item)
           })
            this.allItemsModalNama=true
          })
          .catch();
    },
    submitListConsequencesSelected(){
      this.allListConsequencesModal=false
      this.ListConsequences.forEach((ele)=>{
        parseInt(this.ListConsequencesSelected[0]) === parseInt(ele.id) ? this.selectedConsequesnces = ele.title : ''
      })
    },
    submitListConsequencesNamaSelected(){
      this.allNamaListConsequencesModal=false
      this.otherItems.forEach((ele)=>{
        parseInt(this.ListConsequencesNAMASelected[0]) === parseInt(ele.id) ? this.selected2 = ele.measurement_chart : ''
      })
    },
    allExits() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/definition_of_output/all`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.items) {
              this.ListExits.length = 0
              response.items.forEach((item) => {
                this.ListExits.push(item)
              })
            }
          })
          .catch();
    },
    giveAllConsequences() {
      if (this.selectExit.id) {
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
        var formdata = new FormData();
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };
        fetch(`${this.base_url}/Determining_Mission/select_consequences/${this.selectExit.id}`, requestOptions)
            .then(response => response.json())
            .then(response => {
              if (response.items) {
                this.ListConsequences.length = 0
                this.ListProcess.length = 0
                this.ListParents.length = 0
                this.selectConsequences = response.items[0]


                response.items.forEach((item) => {
                  this.ListConsequences.push(item)
                })

             if (response.process.length===1){
               response.process.forEach((item) => {
                 this.ListProcess.push(item)
               })
                this.selectProcess = response.process[0]
             }else{
               this.ListProcess.push(response.process)
               this.selectProcess = response.process
             }
            if (response.parent){
              response.parent.forEach((item) => {
                this.ListParents.push(item)
                this.ListSubSelected.push(item.id)
              })
                this.selectParent = response.parent[0]
            }


              }
            })
            .catch();
      }

    },
    resetModel(){
      this.selectConsequences=''
      this.selectProcess=''
      this.selectParent=''
      this.selectExit=''
      this.axis=''
      this.title=''
      this.range=''
      this.model_one= false
      this.model_two= false
      this.model_tree= false
      this.model_four= false
      this.model_five= false
      this.model=''
      this.ListConsequencesSelected.length=0
      this.ListConsequencesNAMASelected.length=0
      this.ListSubSelected.length=0
      this.selectedConsequesnces='انتخاب کنید'
      this.selected2='انتخاب کنید'
      this.ListParents.length=0

    },
    resetItems(){
      this.resetModel()
      this.is_update=false
      this.id_item= ''
    },
    store() {

      if (this.axis.length===0){
        toast.error(' محور ماموریتی اجباری است!')
        return;
      }
      else if (this.title.length===0){
        toast.error('عنوان سند بالادستی اجباری است!')
        return;
      }

      else if (!this.model_one &&!this.model_two &&!this.model_tree &&!this.model_four &&!this.model_five){
        toast.error('مدل نقش آفرینی اجباری است!')
        return;
      }
      else if (this.selectConsequences.length===0){
        toast.error('خروجی اجباری است!')
        return;
      }
      else if (this.selectProcess.length===0){
        toast.error('پیامد اجباری است!')
        return;
      }



       var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('definition_of_outputs_id', this.selectExit.id)
      if (this.selectConsequences.type) {
        formdata.append('immediate_consequences_id', this.selectConsequences.id)
      }  if (!this.selectConsequences.type) {
        formdata.append('intermediate_outcomes_id', this.selectConsequences.id)
      }

      formdata.append('processes_id', this.selectProcess.id)
     /* if (this.selectParent && this.selectParent.id){

      formdata.append('sub_processes_id', this.selectParent.id)
      }*/
      formdata.append('axis', this.axis)
      formdata.append('title', this.title)
      formdata.append('range', this.range)
      formdata.append('model_one', this.model_one)
      formdata.append('model_two', this.model_two)
      formdata.append('model_tree', this.model_tree)
      formdata.append('model_four', this.model_four)
      formdata.append('model_five', this.model_five)
      formdata.append('consequences_for_determining_missions', JSON.stringify(this.ListConsequencesSelected))
      formdata.append('consequences_for_determining_missions_nama', JSON.stringify(this.ListConsequencesNAMASelected))
      formdata.append('sub_process', JSON.stringify(this.ListSubSelected))

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Determining_Mission/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              return
            }
             toast.success('عملیات با موفقیت انجام شد!')
            this.resetModel()
            this.allItem()
          })
          .catch();
    },
    update(id) {

      if (this.axis.length===0){
        toast.error(' محور ماموریتی اجباری است!')
        return;
      }
      else if (this.title.length===0){
        toast.error('عنوان سند بالادستی اجباری است!')
        return;
      }


      else if (!this.model_one &&!this.model_two &&!this.model_tree &&!this.model_four &&!this.model_five){
        toast.error('مدل نقش آفرینی اجباری است!')
        return;
      }
      else if (this.selectConsequences.length===0){
        toast.error('خروجی اجباری است!')
        return;
      }
      else if (this.selectProcess.length===0){
        toast.error('پیامد اجباری است!')
        return;
      }



       var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('definition_of_outputs_id', this.selectExit.id)
      if (this.selectConsequences.type) {
        formdata.append('immediate_consequences_id', this.selectConsequences.id)
      }  if (!this.selectConsequences.type) {
        formdata.append('intermediate_outcomes_id', this.selectConsequences.id)
      }

      formdata.append('processes_id', this.selectProcess.id)
      if (this.selectParent && this.selectParent.id){

      formdata.append('sub_processes_id', this.selectParent.id)
      }
      if (this.model_one){this.model_one=1}
      if (this.model_two){this.model_two=1}
      if (this.model_tree){this.model_tree=1}
      if (this.model_four){this.model_four=1}
      if (this.model_five){this.model_five=1}
      formdata.append('axis', this.axis)
      formdata.append('title', this.title)
      formdata.append('range', this.range)
      formdata.append('model_one', this.model_one)
      formdata.append('model_two', this.model_two)
      formdata.append('model_tree', this.model_tree)
      formdata.append('model_four', this.model_four)
      formdata.append('model_five', this.model_five)
      formdata.append('consequences_for_determining_missions', JSON.stringify(this.ListConsequencesSelected))
      formdata.append('consequences_for_determining_missions_nama', JSON.stringify(this.ListConsequencesNAMASelected))
      formdata.append('sub_process', JSON.stringify(this.ListSubSelected))
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Determining_Mission/update/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              return
            }
             toast.success('عملیات با موفقیت انجام شد!')
            this.resetModel()
            this.is_update=false
            this.id_item = ''
            this.allItem()
          })
          .catch();
    },
    allItem(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Determining_Mission/all`, requestOptions)
          .then(response => response.json())
          .then(response => {
            this.status_seconder =false
            this.seconder_ban = false
            this.status_seconder_step = false
            this.approver_ban = false
            this.status_approver = false
            if (response.error){
              toast.error(response.error)
              return
            }
            if (response.status){
              this.status_show = true
            }
            this.allItems.length=0
            response.all.forEach((item)=>{
              this.allItems.push(item)

            })
            if (this.allItems.length!==0){
              this.is_fetch=false
            }
            // new
            if (!response.status_seconder){
              if (response.status){
                this.status_seconder = true
              }
            }
            if (!this.status_approver && this.$cookies.isKey('type_1')){
              this.status_seconder = false
            }
              if (response.status && !response.status_approver){
                  this.status_seconder = true
              }
            if (response.seconder_ban){
              this.seconder_ban = true
              this.textAlert = response.message??'موردی یافت نشد'
            }
            if (response.approver_ban){
              this.approver_ban = true
              this.textAlert = response.message??'موردی یافت نشد'
            }

            if (response.status_approver){
              this.status_approver = true
            }
            if (response.text_seconder){
              this.seconder_ban = true
              this.textAlert = response.text_seconder??'موردی یافت نشد'
            }
            if (parseInt(response.step)===1){
              this.status_seconder_step=true
              this.status_seconder=true
            }
            if (parseInt(response.step)===2){
              this.status_seconder_step=true
              this.status_seconder=false
            }  if (parseInt(response.step)===0){
              this.status_seconder_step=false

            }

            if ((parseInt(response.step)===1&&this.type_two)||(parseInt(response.step)===2&&this.type_two) || (parseInt(response.step)===2&&this.type_one) || parseInt(response.step)===3){
              this.not_show = false
            }

            this.show_insert = response.status_insert
          })
          .catch();
    },
    checkIsMother(){
      if (this.is_mother){
        router.push('/mother_items')
        return
      }

    },
    fetchItems() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/show`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error){
              this.logout()
              return;
            }
            if (result['item']) {
               if (this.is_mother){
              this.id_user = result['item']['id']
                return;
              }
              this.id_user = result['item']['company_id']

            }

          })
          .catch();
    },
    ProductivityPeriod(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/ProductivityPeriod/check`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.status){
              this.isWrite = true
              return
            }else{
              this.isWrite = false
            }



          })
          .catch();
    },
  },

  mounted() {
    this.checkIsMother()
    this.allExits()
    this.allItem()
    this.fetchItems()
    this.ProductivityPeriod()
  },

  watch: {
    selectExit(newValue, oldValue) {
      this.giveAllConsequences()
    },
  }
}
</script>
<style scoped lang="scss">
label {
  font-size: 0.8vw;
}
</style>